import images from './images';

const process = [
  {
    id: 1,
    title: 'Initial Consultation',
    content: 'Begin with an initial consultation to understand your event vision, preferences, and requirements.',
    image: images.step1,
    alt: 'Consultation',
  },
  {
    id: 2,
    title: 'Menu Planning',
    content: 'Professional planning of your menu, considering factors like dietary preferences and seasonal ingredients.',
    image: images.step2,
    alt: 'Menu Planning',
  },
  {
    id: 3,
    title: 'Event Preparation',
    content: 'Meticulous preparation of food and setup of the venue to ensure everything is perfect for your event.',
    image: images.step3,
    alt: 'Event Preparation',
  },
];

export default process;